declare const $: any;

import ComponentSettings from './ComponentSettings';
import Tabs from '../Interfaces/Tabs';
import { availablePlugins } from '../availablePlugins';

export default class Buttongroup extends ComponentSettings {
    private component: any;
    private tabs: Array<Tabs> = [];

    constructor(section) {
        super(section);
        this.component = section.component;
        this.buildTemplate();
    }

    private buildTemplate() {

        /* Main fieldset (= Buttons = tab-items)
        -------------------------------------------------- */

        const $mainTab: Array<JQuery> = [];

        // Center
        const selectCenterData = {
            data: {
                prop: 'center'
            },
            name: 'center',
            label: 'Center',
            value: this.component.center
        }
        const selectCenterOptions: any = [
            {
                'Yes': 'true'
            },
            {
                'No': 'false'
            }
        ];
        const $centerData = this.addSelect(selectCenterData, selectCenterOptions);

        $mainTab.push($centerData);

        const $itemsWrapper = $('<div />').attr('id', 'items-wrapper');

        this.component.buttons.forEach(btn => {
            const $fieldset = this.buildButton(btn);
            $itemsWrapper.append($fieldset);
        });

        $mainTab.push($itemsWrapper);

        this.tabs.push({
            title: 'Buttons',
            id: 'tab-items',
            content: $mainTab
        });

        /* Plugins
        -------------------------------------------------- */

        const $pluginsTab: Array<JQuery> = [];

        // Plugins
        const pluginsOptions: Array<string> = [];
        availablePlugins.button.forEach(Pl => {
            pluginsOptions.push(Pl.name);
        });
        const activePluginsNames: Array<string> = [];
        this.component.plugins.forEach(pl => {
            activePluginsNames.push(pl.name);
        });
        const pluginsData = {
            data: {
                prop: 'plugins'
            },
            label: 'Select plugins',
            name: 'plugins[]',
            value: activePluginsNames
        }
        const $selectPlugins = this.addSelect(pluginsData, pluginsOptions);
        $pluginsTab.push($selectPlugins);

        this.component.plugins.forEach(pl => {
            const $pluginFieldset = this.loadPlugin(pl, this);
            $pluginsTab.push($pluginFieldset);
        });

        this.tabs.push({
            title: 'Plugins',
            id: 'tab-plugins',
            content: $pluginsTab
        });

        this.renderSection(this.tabs);
    }

    private buildButton(btn) {
        const $fieldset = $('<fieldset />').addClass(this.ui.fieldsetClass).attr('data-index', btn.index);
        const legendHtml = `<button class="${this.ui.collapsibleButtonsClass}" type="button" data-bs-toggle="collapse" data-bs-target="#collapsible-option-${btn.index}" aria-expanded="true" aria-controls="collapsible-option-${btn.index}">button ${btn.index}</button>`;
        const $legend = $('<legend />').html(legendHtml).addClass(this.ui.legendClass);
        $fieldset.append($legend);

        const $collapsible = $('<div />').addClass('collapse show').prop('id', `collapsible-option-${btn.index}`);

        // Type
        const typeOptions: Array<string> = ['submit', 'reset', 'button'];
        const typeData = {
            name: 'type',
            label: 'Type',
            data: {
                index: btn.index,
                prop: 'type',
            },
            value: btn.type
        }
        const $selectType = this.addSelect(typeData, typeOptions);
        $collapsible.append($selectType);

        // Name
        const nameData = {
            data: {
                index: btn.index,
                prop: 'name'
            },
            label: 'Name',
            name: 'name',
            value: btn.name
        }
        const $inputName = this.addInput(nameData);
        $collapsible.append($inputName);

        // Value
        const valueData = {
            data: {
                index: btn.index,
                prop: 'value'
            },
            label: 'Value',
            name: 'value',
            value: btn.value
        }
        const $inputValue = this.addInput(valueData);
        $collapsible.append($inputValue);

        // Text
        const labelData = {
            data: {
                index: btn.index,
                prop: 'label'
            },
            label: 'Text',
            helper: 'HTML authorized',
            name: 'label',
            value: btn.label
        }
        const $inputLabel = this.addInput(labelData);
        $collapsible.append($inputLabel);

        // Class
        const clazzData = {
            data: {
                index: btn.index,
                prop: 'clazz'
            },
            label: 'Class',
            name: 'clazz',
            value: btn.clazz
        }
        const $inputClazz = this.addInput(clazzData);
        $collapsible.append($inputClazz);

        $fieldset.append($collapsible);

        // icon
        const iconData = {
            data: {
                prop: 'icon',
                index: btn.index,
                uniqid: this.makeUniqId(5),
                iconset: $('body').attr('data-icon-font'),
                icon: this.component.icon
            },
            label: 'icon',
            name: 'icon'
        }
        const $inputIcon = this.addIconPicker(iconData);
        $fieldset.append($inputIcon);

        // icon position
        const iconPositionData = {
            data: {
                prop: 'iconPosition',
                index: btn.index
            },
            name: 'icon-position',
            label: 'Icon position',
            value: 'before'
        }
        const iconPositionOptions: any = [
            {
                'Before the text': 'before'
            },
            {
                'After the text': 'after'
            }
        ];
        const $selectIconPosition = this.addSelect(iconPositionData, iconPositionOptions);

        $fieldset.append($selectIconPosition);

        return $fieldset;
    }
}
